import axios from 'axios'
import { ADMIN_API_URL } from 'const'

const BASE_URL = `${ADMIN_API_URL}/animated_videos`

export const getAnimatedVideo = async (shareCode) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/${shareCode}`)
    return data.video_url
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const getAnimatedVideoByReclip = async (sourceId) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/by_reclip/${sourceId}`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const getAnimatedVideoDetails = async (sourceId) => {
  try {
    const { data } = await axios.get(
      `${BASE_URL}/details_by_reclip/${sourceId}`
    )
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const getStyleSettings = async () => {
  try {
    const { data } = await axios.get(`${BASE_URL}/styles`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const getStylesPreview = async () => {
  try {
    const { data } = await axios.get(`${BASE_URL}/styles/preview`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const getAsmrStylesPreview = async () => {
  try {
    const { data } = await axios.get(`${BASE_URL}/styles/preview?variant=asmr`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const getEmoticonStylesPreview = async () => {
  try {
    const { data } = await axios.get(
      `${BASE_URL}/styles/preview?variant=emoticon`
    )
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const updateStyleSettings = async (style, settings) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/styles/${style}`, settings)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const removeStylePin = async (style) => {
  try {
    const { data } = await axios.delete(`${BASE_URL}/styles/${style}/pin`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const reorderPinnedStyles = async (styles) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/styles/pin-order`, { styles })
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const getKillSwitch = async () => {
  try {
    const { data } = await axios.get(`${BASE_URL}/kill-switch`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const updateKillSwitch = async (settings) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/kill-switch`, settings)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}
